import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { formatArticleDate } from "../blogs/articleHelpers";
import { initials, lawyerProfileUrl } from "../lawyers/lawyerHelpers";
import { currentUser } from "./questionHelpers";

export default function QuestionComment(props) {
  const Lng = localStorage.getItem("lang");
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [editing, setEditing] = useState(false);
  // Starts from the current text so saving without typing keeps the answer.
  const [newAnswer, setNewAnswer] = useState(props.answer.answer);
  const [photoFailed, setPhotoFailed] = useState(false);
  const author = props.answer.author || {};
  const isLawyer = author.role === "lawyer";
  // The API sends the profile with the answer ({ _id, id, names }), or
  // only { _id } for a profile that is not in the directory.
  const profile = author.lawyerID && typeof author.lawyerID === "object" ? author.lawyerID : null;
  const lawyerId = profile ? profile._id : author.lawyerID;
  const lawyer = profile && profile.id ? profile : null;
  const loggedUserId = currentUser()?.lawyerID?._id;
  const isMine = isLawyer && loggedUserId && loggedUserId === lawyerId;
  const name = isLawyer
    ? [author.firstName, author.lastName].filter(Boolean).join(" ")
    : t("AvoConsulte");
  const photo =
    author.profilePicture && !photoFailed
      ? process.env.REACT_APP_BASE_URL + author.profilePicture.slice(1)
      : null;

  function openProfile() {
    lawyer && navigate(lawyerProfileUrl(lawyer, Lng));
  }

  async function save() {
    await props.edite({ _id: props.answer._id, text: newAnswer });
    setEditing(false);
  }

  return (
    <li className="avc-answer">
      <div className="avc-answer__head">
        <span className="avc-answer__avatar" aria-hidden="true">
          {photo ? (
            <img src={photo} alt="" onError={() => setPhotoFailed(true)} />
          ) : (
            initials(name)
          )}
        </span>
        <div className="avc-answer__who">
          {lawyer ? (
            <button type="button" onClick={openProfile} className="avc-answer__name">
              {name}
            </button>
          ) : (
            <span className="avc-answer__name">{name}</span>
          )}
          <span className="avc-answer__meta">
            {isLawyer && (
              <span className="avc-answer__badge">
                <i className="fas fa-balance-scale" aria-hidden="true"></i>
                {t("qa_lawyer_badge")}
              </span>
            )}
            {props.answer.createdAt && (
              <time dateTime={props.answer.createdAt}>
                {formatArticleDate(props.answer.createdAt, Lng)}
              </time>
            )}
          </span>
        </div>
      </div>

      {editing ? (
        <div className="avc-answer__edit">
          <textarea
            className="avc-textarea"
            rows={5}
            value={newAnswer}
            onChange={(e) => setNewAnswer(e.target.value)}
          />
          <div className="avc-answer__actions">
            <button
              type="button"
              className="avc-btn avc-btn--gold"
              onClick={save}
              disabled={!newAnswer.trim()}
            >
              {t("qa_save")}
            </button>
            <button
              type="button"
              className="avc-btn avc-btn--outline"
              onClick={() => {
                setNewAnswer(props.answer.answer);
                setEditing(false);
              }}
            >
              {t("Cancel")}
            </button>
          </div>
        </div>
      ) : (
        <p className="avc-answer__text" dir="auto">
          {props.answer.answer}
        </p>
      )}

      {isMine && !editing && (
        <div className="avc-answer__owner">
          <button type="button" onClick={() => setEditing(true)}>
            <i className="far fa-edit" aria-hidden="true"></i>
            {t("Edit")}
          </button>
          <button type="button" onClick={() => props.delete({ _id: props.answer._id })}>
            <i className="far fa-trash-alt" aria-hidden="true"></i>
            {t("Delete")}
          </button>
        </div>
      )}
    </li>
  );
}
